import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./ResourceLocation.css"

export const ResourceLocation = () => {
  return (
        <>
        <RoutingMenu activeScreen="resourceLocation" />
    <div className=''>

        <iframe
            src={`${config.RootUrl}/faculty/library/location/locationHTML.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
